import { Fragment, useState } from 'react';
import  Link  from "next/link";
import { useRouter } from "next/router";
import Image from "next/image";
import enIN from '@/locales/common/enIN';
import esMX from '@/locales/common/esMX';
import enUS from '@/locales/common/enUS';

export default function Menuitem() {
    const router = useRouter();
    const { locale } = router;
    const t = (locale === 'es-mx' && esMX) || (locale === 'en-us' && enUS) || (locale === 'en-in' && enIN);
    
    const [isHovered, setIsHovered] = useState(null);

    
    
    // const handleConversion = () => {
    //     const conversionId = 'AW-11325447679/uX8RCPrflOAYEP-7spgq';
    //     window.gtag('event', 'conversion', {
    //       'send_to': conversionId,
    //     });
    //   };


    const routerPathExport = router.pathname == "/export-factoring" || 
    router.pathname == "/export-factoring/invoice-discounting-platform" || 
    router.pathname == "/export-factoring/purchase-order-financing" || 
    router.pathname == "/partner-program" || router.pathname == "/business-loan";


    
    return <div className="w-[50%] sm:hidden lg:w-[70%] xl:w-[66%] md:w-[73%]">
           

            <div className="flex items-center justify-between">
                <div>
                    <ul className="flex ml-5 items-center nav-link-desktop">
                        {t.MenuLinks &&
                        t.MenuLinks.map((item,i)=>(
                        <li key={i} className=" px-[13px] md:px-1 text-sm font-regular text-brand relative group" onMouseEnter={() => setIsHovered(item.name)} onMouseLeave={() => setIsHovered(null)}>
                          <div className="relative">
                          {item.subMenu ?
                                  <div className={router.asPath == item.href ? "text-brand flex items-center" : "text-brand flex  items-center"}>
                                      <span className="text-sm md:text-xs">{item.name}</span>
                                       
                                      <svg className=' relative' xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16" 
                                      aria-hidden="true"><path fill="none" d="M0 0h24v24H0z"/><path fill={routerPathExport ? "#022B5C" : ""} d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" /></svg>
                                    
                                  </div>:
                                  <Link href={item.href} className={router.asPath == item.href ? "text-brand flex items-center" : "text-brand flex  items-center"}>
                                  <span className="text-sm md:text-xs">{item.name}</span>
                                  </Link>
                                 
                                
                              }
                              <div className="absolute bottom-[-10px] left-0 w-full h-[4px] bg-gradient-to-r from-[#022B5C] to-[#0363C4] transform origin-bottom scale-x-0 transition-transform duration-200 group-hover:scale-x-100 rounded-[5px] shadow-md"
                                        style={{ transform: router.asPath.includes (item.href) || isHovered == item.name     ? 'scaleX(1)' : 'scaleX(0)' }}>
                                    </div>
                             
                              
                              {item.subMenu &&
                                //   <div className={`${item.subMenu.length > 2 ? 'w-[980px]':'w-[300px] left-[-100px] md:left-[-145px]'} absolute invisible group-hover:visible z-10 pt-[25px] transform sm:px-0`}>
                                <div className={`absolute invisible group-hover:visible z-10 pt-[15px] transform sm:px-0
                                    ${ item.subMenu.length > 2 ? item.name === "Tools"
                                          ? 'w-[980px] left-[-281px]' : item.name === "Resources"
                                            ? 'w-[980px] left-[-357px]' : 'w-[980px]' 
                                        : 'w-[300px] left-[-100px] md:left-[-145px]'  }`}>
                                        
                                     <div className="overflow-hidden shadow-sm">
                                          <div className="relative grid bg-white py-[15px] px-[25px]">
                                          <ul className="flex items-center flex-wrap w-full">
                                          {item.subMenu.map((item1,index) => (
                                              <li
                                              key={index}
                                              // onClick={() => handleMenuSabCategoryClick('Financing Solutions', item.name)}
                                              className={`${router.asPath === item1.href ? "text-brand font-regular" : "font-regular"} ${item.subMenu.length > 2 ? 'w-[33%]' : 'w-full'} mb-2 ${router.asPath === item1.href || index === 2 || index === 5 ? '' : 'pr-2'}`}>
                                                  <Link href={item1.href}  rel="noopener noreferrer" className="block text-sm rounded-md transition px-[10px] py-1 duration-150 ease-in-out hover:text-brand hover:bg-[#f3f3f3]">
                                                      <div className="flex items-start">
                                                        {item1.src &&
                                                            <Image src={item1.src} width={30} height={30} className='w-[30px] h-auto' alt={item1.name}  />  
                                                        }
                                                          <div className="pl-1">
                                                              <p className="text-sm mb-[5px]">{item1.name}</p>
                                                              <p className="text-xs text-secondary">{item1.text}</p>
                                                          </div>
                                                      </div>
                                                  </Link>
                                              </li>
                                          ))}
                                          </ul>
                                          </div>
                                      </div>
                                  </div>

                              }

                          </div>
                      </li>
                        ))
                          
                        }
                       
                    </ul>
                </div>

                
            </div>
        </div>
}

